import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  downloadReservationICS,
  generateOutlookReservationURL,
  generateGoogleReservationURL
} from '../../utils/calendarUtils';
import { Reservation } from './types';

interface CalendarExportMenuProps {
  anchorEl: HTMLElement | null;
  reservation: Reservation | null;
  onClose: () => void;
}

const CalendarExportMenu: React.FC<CalendarExportMenuProps> = ({ anchorEl, reservation, onClose }) => {
  const { t } = useTranslation();

  const handleAction = (action: 'outlook' | 'google' | 'ics') => {
    if (!reservation) return;

    const translations = {
      reservationEvent: t('calendar.reservationEvent'),
      organizer: t('stiklainis.organizer')
    };

    if (action === 'outlook') {
      const url = generateOutlookReservationURL(reservation, translations);
      if (url) window.open(url, '_blank');
    } else if (action === 'google') {
      const url = generateGoogleReservationURL(reservation, translations);
      if (url) window.open(url, '_blank');
    } else if (action === 'ics') {
      downloadReservationICS(reservation, translations);
    }

    onClose();
  };

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={() => handleAction('outlook')}>{t('calendar.outlook')}</MenuItem>
      <MenuItem onClick={() => handleAction('google')}>{t('calendar.google')}</MenuItem>
      <MenuItem onClick={() => handleAction('ics')}>{t('calendar.downloadICS')}</MenuItem>
    </Menu>
  );
};

export default CalendarExportMenu;
